export default __webpack_public_path__ + "static/media/candidates_informed.2ba87582.svg";